import React from 'react';
import { useStableParams } from '../../routes/useStableParams';

const CalculationDetailSubpage: React.FC = () => {
  const { calculationId } = useStableParams();

  return <div>This is Calculation detail subpage - {calculationId}</div>;
};

export default CalculationDetailSubpage;
